module.exports = __webpack_public_path__ + "img/title3.e153926a.png";